// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"614":"c1029eb2","744":"59b283fa"}[chunkId] + ".chunk.css";
};